import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-backdrop',
  templateUrl: './backdrop.component.html',
  styles: [
  ]
})
export class BackdropComponent implements OnInit {
  @Input('titulo') titulo!: string;
  constructor() { }

  ngOnInit(): void {
  }

}
